import React from "react";
import { QueueStats, Status } from "../../types/statusTypes";
import QueueVolumeCardListItem from "./QueueVolumeCardListItem";

interface QueueVolumeCardProps {
  title: string;
  stats: QueueStats;
}

export default function QueueVolumeCard({ title, stats }: QueueVolumeCardProps) {
  return (
    <div className="card">
      <h2 className="card-title p-3 m-0 h4">{title}</h2>
      <ul className="list-group list-group-horizontal border-0">
        <QueueVolumeCardListItem status={Status.Pending} count={stats.pendingCount} />
        <QueueVolumeCardListItem status={Status.InProgress} count={stats.inProgressCount} />
        <QueueVolumeCardListItem status={Status.Complete} count={stats.completeCount} />
        <QueueVolumeCardListItem status={Status.Failed} count={stats.failedCount} />
        <QueueVolumeCardListItem status={Status.Revoked} count={stats.revokedCount} />
      </ul>
    </div>
  );
}
